import React from 'react';

import { useBulkEdit } from 'scenes/Gallery/GalleryPage/Creatives/data';
import BulkEditForm from './BulkEditForm';
import { IDS } from './constants';

export const BulkEditCreativesForm = ({
  selectedRows,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [edit, { isLoading }] = useBulkEdit();

  const handleSubmit = async (values) => {
    await edit(values);
    onSubmit();
  };

  return (
    <BulkEditForm
      title={'Bulk Edit'}
      selectedRows={selectedRows}
      initialValues={{
        [IDS]: selectedRows.map(({ id }) => id),
      }}
      loading={isLoading}
      onClose={onClose}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
    />
  );
};
